import React from "react"
import ClinicalHistoryBaseEditorLayout from "../features/clinical-history/components/ClinicalHistoryBaseEditorLayout"
import BaseClinicalHistoryForm from "../features/clinical-history/components/BaseClinicalHistoryForm"
import { DiagnosisInitialModal } from "../features/clinical-history/components/ClinicalHistoryModals"

export default function ClinicalHistoryBaseEditorPage({
  patientDisplayName,
  isFormDirty,
  isReadOnly,
  readOnlyReason,
  saving,
  onBackToSummary,

  baseFormSectionCount,
  form,
  age,
  updateField,
  chiefComplaintOptions,
  habitOptions,
  tmjOptions,
  medicalOptions,

  onOpenOdontogram,
  onOpenDiagnosis,
  onPersistClinicalHistory,
  onSaveDraft,

  diagnosisModal,
}) {
  return (
    <div style={{ padding: 24, background: "#f8fafc", minHeight: "100vh" }}>
      <DiagnosisInitialModal
        open={diagnosisModal.open}
        onClose={diagnosisModal.closeModal}
        form={diagnosisModal.form}
        setForm={diagnosisModal.setForm}
        saving={diagnosisModal.saving || diagnosisModal.loading}
        onSave={diagnosisModal.saveInstance}
        latestInstance={diagnosisModal.latestInstance}
        isReadOnly={isReadOnly}
        readOnlyReason={readOnlyReason}
      />

      <ClinicalHistoryBaseEditorLayout
        patientDisplayName={patientDisplayName}
        isFormDirty={isFormDirty}
        isReadOnly={isReadOnly}
        readOnlyReason={readOnlyReason}
        saving={saving}
        onBackToSummary={onBackToSummary}
      >
        <BaseClinicalHistoryForm
          baseFormSectionCount={baseFormSectionCount}
          form={form}
          age={age}
          saving={saving}
          isReadOnly={isReadOnly}
          updateField={updateField}
          chiefComplaintOptions={chiefComplaintOptions}
          habitOptions={habitOptions}
          tmjOptions={tmjOptions}
          medicalOptions={medicalOptions}
          onOpenOdontogram={onOpenOdontogram}
          onOpenDiagnosis={onOpenDiagnosis}
          onPersistClinicalHistory={onPersistClinicalHistory}
          onSaveDraft={onSaveDraft}
        />
      </ClinicalHistoryBaseEditorLayout>
    </div>
  )
}